"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var components_1 = require("@lsg/components");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var react_components_1 = require("@lws/react-components");

var utils_1 = require("../utils");

var rich_text_types_1 = require("@contentful/rich-text-types");

var util_1 = require("@lws/react-components/dist/components/RichTextRenderer/renderers/util");

exports.QuoteComponent = function (_a) {
  var _b;

  var data = _a.data;

  var _c;

  var quote = data.richText('quoteText', utils_1.emptyDocument);
  var author = data.text('author', '');
  var authorPosition = data.text('authorPosition', '');
  var authorImage = data.image('authorImage');
  return react_1["default"].createElement(components_1.Section, null, react_1["default"].createElement(components_1.Grid, null, react_1["default"].createElement(GridRow_1.GridRow, {
    verticalAlign: (_c = components_1.Grid.VerticalAlign) === null || _c === void 0 ? void 0 : _c.TOP
  }, react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 0,
    sm: 0,
    md: 1,
    lg: 1,
    xl: 1
  }), react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 12,
    sm: 12,
    md: 7,
    lg: 7,
    xl: 7
  }, react_1["default"].createElement(Quote, null, react_1["default"].createElement(react_components_1.ContentfulRichTextRenderer, {
    content: quote,
    options: {
      renderNode: (_b = {}, _b[rich_text_types_1.BLOCKS.PARAGRAPH] = util_1.createSimpleComponentRendererFor(components_1.H3Thin, {
        asSpan: true
      }), _b)
    }
  }), react_1["default"].createElement(react_components_1.Person, {
    name: author,
    position: authorPosition,
    avatar: authorImage
  }))))));
};

var Quote = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 24px 0;\n  padding: 0;\n  padding-left: 60px;\n  position: relative;\n  &::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    background-color: #ffcc00;\n    width: 3px;\n    top: 0;\n    bottom: 0;\n  }\n  h3,\n  ", " {\n    margin: 0;\n    & p {\n      margin: 0;\n    }\n  }\n  h3 {\n    padding-top: 5px;\n    padding-bottom: 16px;\n  }\n  ", " {\n    padding-bottom: 5px;\n    padding-top: 24px;\n  }\n\n  @media (min-width: 1024px) {\n    h3,\n    ", " {\n      position: relative;\n      margin: 0;\n    }\n\n    h3 {\n      padding-bottom: 24px;\n    }\n\n    ", " {\n      padding-top: 0;\n    }\n  }\n  @media (max-width: 1023px) {\n    padding-left: 20px;\n  }\n  @media (max-width: 639px) {\n    padding-left: 16px;\n  }\n"], ["\n  margin: 24px 0;\n  padding: 0;\n  padding-left: 60px;\n  position: relative;\n  &::before {\n    position: absolute;\n    content: '';\n    left: 0;\n    background-color: #ffcc00;\n    width: 3px;\n    top: 0;\n    bottom: 0;\n  }\n  h3,\n  ", " {\n    margin: 0;\n    & p {\n      margin: 0;\n    }\n  }\n  h3 {\n    padding-top: 5px;\n    padding-bottom: 16px;\n  }\n  ", " {\n    padding-bottom: 5px;\n    padding-top: 24px;\n  }\n\n  @media (min-width: 1024px) {\n    h3,\n    ", " {\n      position: relative;\n      margin: 0;\n    }\n\n    h3 {\n      padding-bottom: 24px;\n    }\n\n    ", " {\n      padding-top: 0;\n    }\n  }\n  @media (max-width: 1023px) {\n    padding-left: 20px;\n  }\n  @media (max-width: 639px) {\n    padding-left: 16px;\n  }\n"])), react_components_1.PersonWrapper, react_components_1.PersonWrapper, react_components_1.PersonWrapper, react_components_1.PersonWrapper);
var templateObject_1;